// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bHFS","colBig":"styles_colBig__zxu95","colSmall":"styles_colSmall__11NRB"};